import React, { useEffect, useState, useContext} from 'react'
import logic from "./RenegadeOSLiteLogic"
import typewriterConfig from "../typewriter/typewriterConfig"
import FirebaseContext from "../../common/firebase/context"


const RenegadeOSLiteController = ({html, allPosts, children, logo, setProgressValue, setOpenContents}) => {

    //setup the data with the html
    logic.attachHtmlToChunksData(html)
    logic.createProgressData()


    //Setup state
    const [showButtons, setShowButtons] = useState(false)
    const [typingState, setTypingState] = useState(null)

    const {user, firebase, loading, loadingUserInfo} = useContext(FirebaseContext)
    let _startingChunkUidArray;
    //Retrieve the last chunks
    useEffect(() => {
        if (user && user.lastChunkArray) {
            _startingChunkUidArray = user.lastChunkArray
        }
        else if (localStorage.getItem('lastChunk')) {
            const uid = localStorage.getItem('lastChunk')
            const chunk = logic.getChunkWithUid(uid)
            if (chunk) {
                _startingChunkUidArray = [localStorage.getItem('lastChunk')]
            }
            else {
                _startingChunkUidArray = []
            }

        }
        else {
            _startingChunkUidArray = []
        }
        const content = logic.preloadContentBackwards(_startingChunkUidArray)
        if (content.length > 0) {
            const active = content[content.length - 1]
            if (active.isRenegadeOS) {
                setProgressValue(active.progress)
            }
            else {
                setProgressValue(null)
            }
        }
        setCompletedChunks(content)
    }, [])


    const [finished, setFinished] = useState(false)
    const [restarting, setRestarting] = useState(false)

    const [completedChunks, setCompletedChunks] = useState([])
    const [activeTypewriter, setActiveTypewriter] = useState(null)
    const [chosenButtons, setChosenButtons] = useState([])

    const getActiveChunk = () => {
        if (completedChunks && completedChunks.length > 0) {
            return completedChunks[completedChunks.length - 1]
        }
        else return null
    }

    ///Wrap all the data up into a data object that I can pass to logic
    const data = {
        typingState,
        activeTypewriter,
        activeChunk: () => {
            return getActiveChunk()
        },
        setFinished: (v) => {
            setFinished(v)
        },
        setActiveChunk: (v) => {
            setCompletedChunks([
                ...completedChunks,
                v
            ])
        },
        setChosenButton: (v) => {
            setChosenButtons([...chosenButtons, v])
        },
        setShowButtons: (v) => {
            setShowButtons(v)
        },
        setTypingState: (v) => {
            setTypingState(v)
        },
        setProgressValue: (v) => {
            if (setProgressValue) {
                setProgressValue(v)
            }
        },
        setOpenContents: (v) => {
            if (setOpenContents) {
                setOpenContents(v)
            }
        }
    }

    useEffect(() => {
        if (!showButtons) {
            logic.startTypewriter(data)
        }
    }, [activeTypewriter])


    useEffect(() => {
        if (completedChunks && completedChunks.length > 0) {
            if (!getActiveChunk().typing) {
                const callback = logic.finishedTypingCallback(data)
                callback()
            }
        }

        //Update the saved chunk
        if (getActiveChunk()) {
            const chunkUid = getActiveChunk().uid
            if (chunkUid) {
                if (user && firebase) {
                    firebase.updateLastChunkArray({
                        user,
                        chunkUid
                    })
                }
                else {
                    window.localStorage.setItem("lastChunk", chunkUid);
                }
            }
        }
    }, [completedChunks])


    //Wrap this controller around RenegadeOSLiteView.
    if (!restarting) {
        return (
            children({
                handleButtonClick: ({buttonIndex, chunkUid}) => {
                    logic.handleButtonClick({
                            ...data,
                            buttonIndex,
                            print: false
                        }
                    )
                },
                setActiveTypewriter: (typewriter) => {
                    setActiveTypewriter(typewriter)
                },
                restartExperience: () => {
                    setCompletedChunks(logic.preloadContentBackwards([]))
                    setProgressValue(null)
                },
                goToEnd: () => {
                    setCompletedChunks(logic.preloadContentBackwards(["gyrec"]))
                    setProgressValue(100)
                },
                tw: {
                    onInit: (tw) => {
                        setActiveTypewriter(tw)
                    },
                    options: typewriterConfig.options
                },
                getChosenButtonTextForChunk: (chunk) => {
                    //Figure out the chosen button text
                    let buttonText = ""
                    if (chunk.buttons && chunk.buttons.length > 0) {
                        buttonText = chunk.buttons[0].processedHTML
                    }
                    chosenButtons.forEach(obj => {
                        if (obj.chunkId === chunk.id) {
                            if (chunk.buttons && chunk.buttons.length > 0) {
                                buttonText = chunk.buttons[obj.buttonIndex].processedHTML
                            }
                        }
                    })
                    return buttonText
                },
                showButtons,
                allPosts,
                finished,
                logo,
                completedChunks,
                typingState,
            })
        )
    }
    else return null

}

export default RenegadeOSLiteController
